export default "__VITE_ASSET__CfKBXc0Y__"